import { useApi } from '@backstage/core-plugin-api';
import { useQuery } from '@tanstack/react-query';
import { notificationApiRef } from '../notificationApiRef';
import { NOTIFICATION_KINDS_KEY } from './reactQuery';

export const useNotificationKinds = (options?: { enabled?: boolean }) => {
  const notificationApi = useApi(notificationApiRef);

  return useQuery({
    queryKey: [NOTIFICATION_KINDS_KEY],
    queryFn: () => notificationApi.getNotificationKinds({}),
    enabled: options?.enabled,
    // we don't need to ever invalidate the cache, notification kinds can't change at runtime
    staleTime: Infinity,
  });
};
